<template>
  <div class="content-container">
    <search-comp @onSearch="attachData" @onReset="onReset">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Mã đặt phòng</div>
                <div class="child-w-80">
                  <!-- v-model="searchParams.roomNumber" -->
                  <input v-model="searchParams.roomBookingCode" type="text" />
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Khách sạn</div>
                <div class="child-w-80">
                  <el-select
                    v-model="searchParams.hotelId"
                    :disabled="disabledDate"
                    multiple
                    collapse-tags
                  >
                    <el-option
                      v-for="(hotel, index) in hotelList"
                      :key="index"
                      :value="hotel.id"
                      :label="hotel.name"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>

            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Từ ngày</div>
                <div class="child-w-80">
                  <!-- :date-data="agentItem.representative_card_date" -->
                  <!-- v-model="agentItem.representative_card_date" -->
                  <!-- @changeCalendar="onChangeDate2" -->
                  <CalendarRange
                    v-model="datetimeRange"
                    style="display: block; width: 500px"
                    :disabled="disabledDate"
                    mode="date"
                    @input="setDateRange"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>
    <div class="content-box">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-title-container justify-space-between">
            <div class="das-form-title">
              <span class="main-title">Báo cáo khách hủy</span>
            </div>
            <div class="button-containers-title">
              <InfoBtn @click="dialogFormVisible = true" />
              <el-dropdown trigger="click" @command="handleCommand">
                <button class="btn medium primary outline download-button">
                  <i class="el-icon-download"></i>
                </button>
                <el-dropdown-menu>
                  <el-dropdown-item command="pdf">Xuất PDF</el-dropdown-item>
                  <el-dropdown-item command="excel"
                    >Xuất Excel</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <button class="btn primary small">Xuất Excel</button> -->
            </div>
            <!-- <button class="btn medium primary outline">Thêm</button> -->
          </div>
          <hr />
          <div v-loading="loading" class="grid-scroll mt-10">
            <GridVx
              ref="agGrid"
              :columns="columns"
              :rows="rows"
              class="agGrid"
              :auto-size-cell="true"
              :header-height-setter="headerHeightSetter"
              :is-header-height-setter="true"
              :default-col-def="defaultColDef"
              :auto-select-first-row="false"
              row-selection="false"
            />
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="Chú thích"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <ul class="annotate-container">
            <li>Mã đặt phòng: Hiển thị mã đặt phòng</li>
            <li>Tên khách: Tên khách trong đặt phòng</li>
            <li>Nguồn: nguồn của đặt phòng</li>
            <li>Ngày đến: Ngày khách dự kiến đến. format mặc định: DDMMYYYY</li>
            <li>
              Ngày đi: Ngày đi dự kiến của khách theo đặt phòng. format mặc
              định: DDMMYYYY
            </li>
            <li>Ngày hủy: Ngày hủy đặt phòng. Theo format DDMMYYYY HHMMSS</li>
            <li>Tài khoản hủy: Tài khoản nhân viên thực hiện hủy đặt phòng</li>
            <li>Lý do hủy: Hiển thị lý do hủy khi hủy đặt phòng</li>
            <li>Đã cọc: số tiền đã được khách cọc khi đặt phòng</li>
            <li>
              Trả: Số tiền sẽ trả lại khi hủy đặt phòng, được đi theo chính sách
            </li>
          </ul>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small" @click="dialogFormVisible = false">
            {{ $t('button.cancel') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'
import { getAllHotel } from '@/api/hotel'
import InfoBtn from './components/InfoBtn.vue'
import {
  getCancelGuestList,
  getCancelGuestExcel
} from '@/api/report_service/cancelGuestReport'
import { DEFAULT_GRID_ROW_HEIGHT } from '@/constant'

export default {
  components: {
    CalendarRange,
    InfoBtn
  },
  data() {
    return {
      disabledDate: false,
      loading: false,
      defaultColDef: {
        flex: 1,
        // resizable: true,
        // sortable: true,
        suppressMovable: true,
        autoHeight: true,
        wrapText: true,
        headerComponentParams: {
          template:
            '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            // '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
            // '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
            // '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
            // '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
            '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
            // '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
            '</div>'
        }
      },
      dialogFormVisible: false,
      hotelList: [],
      defaultDatetimeRange: {
        start: this.$moment().format('YYYY-MM-DD'),
        end: this.$moment().format('YYYY-MM-DD')
      },
      datetimeRange: {
        start: this.$moment().format('YYYY-MM-DD'),
        end: this.$moment().format('YYYY-MM-DD')
      },

      defaultSearchParams: {
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().format('YYYY-MM-DD'),
        roomBookingCode: '',
        hotelId: []
      },
      searchParams: {
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().format('YYYY-MM-DD'),
        roomBookingCode: '',
        hotelId: []
      },
      columns: [
        // {
        //   headerName: '',
        //   field: 'index',
        //   minWidth: 60,
        //   maxWidth: 60,
        //   headerCheckboxSelection: true,
        //   headerCheckboxSelectionFilteredOnly: true,
        //   checkboxSelection: true,
        //   resizable: false
        //   // cellStyle: {'padding-left': '12px'}
        // },
        {
          headerName: this.$t('grid.column.bookingCode'),
          field: 'room_booking_code',
          tooltipField: 'room_booking_code',
          cellRenderer: params => {
            if (params.value) {
              return `<div>${params.value}</div>`
            }
          },
          // cellClass: "grid-cell-centered",
          sortable: false,
          minWidth: 120
        },
        {
          headerName: this.$t('grid.column.customerName'),
          field: 'customerName',
          tooltipValueGetter: params => {
            return params.data.last_name + ' ' + params.data.first_name
          },
          // tooltipField: 'name',
          valueGetter: params => {
            return params.data.last_name + ' ' + params.data.first_name
          },
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          minWidth: 100
        },
        {
          headerName: this.$t('grid.column.source'),
          field: 'source_c',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 100

          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.roomLevel'),
          field: 'room_level_nm',
          tooltipField: 'room_level_nm',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 120

          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.roomNum'),
          field: 'num_of_room',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 80,
          maxWidth: 100
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.arrivalDate'),
          field: 'arrive_date',
          // cellRenderer: 'CellRenderTextInput',
          valueGetter: params => {
            if (params.data.arrive_date) {
              return this.$moment(params.data.arrive_date).format('DD-MM-YYYY')
            } else {
              return ''
            }
          },
          sortable: false,
          minWidth: 120,
          maxWidth: 120
          // cellClass: "grid-cell-centered",
        },

        {
          headerName: this.$t('grid.column.departureDate'),
          field: 'depart_date',
          valueGetter: params => {
            if (params.data.depart_date) {
              return this.$moment(params.data.depart_date).format('DD-MM-YYYY')
            } else {
              return ''
            }
          },
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 120,
          maxWidth: 120
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.cancelDate'),
          field: 'cancel_date',
          // valueGetter: params => {
          //   if (params.data.cancel_date) {
          //     return this.$moment(params.data.cancel_date).format('DD-MM-YYYY')
          //   } else {
          //     return ''
          //   }
          // },
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 120,
          maxWidth: 120
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.cancelAccount'),
          field: 'sale_agent_cancel_nm',
          tooltipField: 'sale_agent_cancel_nm',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 120
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.cancelReason'),
          field: 'cancel_reason_cd',
          tooltipField: 'cancel_reason_cd',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 120
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.deposited'),
          field: 'deposit',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          tooltipValueGetter: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            }
            return null
          },
          // cellClass: "grid-cell-centered",
          valueFormatter: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            }
            return null
          },
          minWidth: 100
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.pay'),
          field: 'payment_for_guest',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          tooltipValueGetter: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            }
            return null
          },
          // cellClass: "grid-cell-centered",
          valueFormatter: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            }
            return null
          },
          minWidth: 100
          // cellClass: "grid-cell-centered",
        }
      ],
      rows: []
    }
  },
  computed: {
    recode() {
      return this.searchParams.roomBookingCode
    }
  },
  watch: {
    recode: {
      handler(val) {
        if (val) {
          this.disabledDate = true
          this.datetimeRange = {
            start: null,
            end: null
          }
          this.searchParams.dateFrom = null
          this.searchParams.dateTo = null
          this.searchParams.hotelId = []
        } else {
          this.disabledDate = false
          this.datetimeRange = {
            start: this.$moment().format('YYYY-MM-DD'),
            end: this.$moment().format('YYYY-MM-DD')
          }
          this.searchParams.dateFrom = this.$moment().format('YYYY-MM-DD')
          this.searchParams.dateTo = this.$moment().format('YYYY-MM-DD')
        }
      },
      deep: true
    }
  },
  created() {
    this.getListHotel()
  },
  mounted() {
    this.attachData()
  },
  methods: {
    handleCommand(cmmd) {
      if (cmmd == 'excel') {
        // alert('excel')
        // let data = await getCancelGuestExcel(this.searchParams)
        getCancelGuestExcel(this.searchParams).then(res => {
          if (res) {
            const date = this.$moment().format('DD-MM-YYYY')
            const href = URL.createObjectURL(res)
            // create "a" HTML element with href to file & click
            const link = document.createElement('a')
            link.href = href
            link.setAttribute(
              'download',
              'guest_cancel_report_' + date + '.xlsx'
              // res.headers['content-disposition'].split('filename=')[1],
            ) // or any other extension
            document.body.appendChild(link)
            link.click()
            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link)
            URL.revokeObjectURL(href)
          } else {
            throw new Error(res)
          }
        })
      }
    },
    headerHeightGetter() {
      var columnHeaderTexts = [
        ...document.querySelectorAll('.ag-header-cell-text')
      ]
      var clientHeights = columnHeaderTexts.map(
        headerText => headerText.clientHeight
      )
      var tallestHeaderTextHeight = Math.max(...clientHeights)

      return tallestHeaderTextHeight
    },
    headerHeightSetter() {
      var padding = 30
      var height = this.headerHeightGetter() / 2 + padding
      this.$refs.agGrid.gridApi.setHeaderHeight(height)
      this.$refs.agGrid.gridApi.resetRowHeights()
    },
    async getListHotel() {
      const data = await getAllHotel()
      this.hotelList = data.data
    },
    setDateRange(range) {
      this.searchParams.dateFrom = range.start
      this.searchParams.dateTo = range.end
    },
    onReset() {
      this.searchParams = { ...this.defaultSearchParams }
      this.datetimeRange = { ...this.defaultDatetimeRange }
      this.attachData()
    },
    convertRowData(rows) {
      try {
        let newDataRow = []
        rows.forEach(data => {
          let fullWidthRow = {
            isFullWidthRow: true,
            name: data.traveller_type + ' ' + data.booking_group_code
          }
          newDataRow = [
            ...newDataRow,
            fullWidthRow,
            ...data.guest_cancel_detail
          ]
        })
        return newDataRow
      } catch (error) {
        console.log(error)
      }
    },
    async attachData() {
      try {
        this.loading = true
        let data = await getCancelGuestList(this.searchParams)
        this.loading = false
        // this.rows = []

        this.rows = this.convertRowData(data.data)

        // this.rows = data.data
      } catch (error) {
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss"></style>
